import type { RateView } from "@checkone/contract/client";
import { PAYEE_LABEL, RATE_REASON, formatDay, pct, sectionLabel } from "../lib/format";

/** A quoted rate with its section and rate-table version, or why there is none. Never computed. */
export function RateCell({ rate, showPayee = false }: { rate: RateView | null; showPayee?: boolean }) {
  if (!rate) return <span className="muted">—</span>;
  if (rate.kind === "rate_unavailable") {
    return (
      <span className="rate">
        <span className="muted">{RATE_REASON[rate.reason] ?? "No rate"}</span>
        <span className="meta">{sectionLabel(rate.section)}</span>
      </span>
    );
  }
  return (
    <span className="rate">
      <strong>{pct(rate.rate_pct)}</strong>
      <span className="meta">
        {sectionLabel(rate.section)}
        {showPayee && <> · {PAYEE_LABEL[rate.payee_type]}</>} · rate table v{rate.rate_table.version}
        <span className="sr-only"> effective {formatDay(rate.rate_table.effective_from)}</span>
      </span>
    </span>
  );
}
